export const FETCH_EMPLOYMENT_TYPES_END = "setEmploymentTypeList";
export const FILTER_PERSONNEL_BY_EMPLOYMENT_TYPE = "filterPersonnelByEmploymentType";
